import axios from "../../axios";
import { toast } from "react-toastify";
import { GET_SALES_REPRESENTATIVE, ADD_SALES_REPRESENTATIVE, UPDATE_SALES_REPRESENTATIVE, DELETE_SALES_REPRESENTATIVE, GET_ONE_SALES_REPRESENTATIVE} from "../types";

export const getSalesRepresentative = (params) => async (dispatch) => {
    try {
      const res = await axios.get('/salesR/all', {params});
      
      if (res.data.code === 1) {
        dispatch({ type: GET_SALES_REPRESENTATIVE,
          payload: {
            data: res.data.data || [],
            pagination: res.data.pagination || {},
            totalCount: res.data.totalCount || 0,
        },});
      }
      if (res.data.code === 2) {
        setTimeout(() => {
          toast.warn(res.data.message);
        }, 1000);
      }
    } catch (err) {
      if(err.response.data.errors[0].message){
        toast.error(err.response.data.errors[0].message);
      }
    }
};

export const addSalesRepresentative = (formData) => async (dispatch) => {
    try {
      const res = await axios.post('/salesR/add', formData);
      if (res.data.code === 0) {
        
        setTimeout(() => {
          toast.error(res.data.message);
        }, 1000);
      } 
      if (res.data.code === 1) {
        dispatch({ type: ADD_SALES_REPRESENTATIVE, payload: res.data.data });
        setTimeout(() => {
          toast.success("Sales Representative added successfully!");
        }, 1000);
      }
      if (res.data.code === 2) {
        setTimeout(() => {
          toast.warn(res.data.message);
        }, 1000);
      }
    } catch (err) {
      if(err.response.data.errors[0].message){
        toast.error(err.response.data.errors[0].message);
      }
    }
};

export const updateSalesRepresentative = (formData) => async (dispatch) => {
    try {
      const res = await axios.post(`/salesR/update`, formData);
  
      if (res.data.code === 1) {
        dispatch({ type: UPDATE_SALES_REPRESENTATIVE, payload: res.data.data });
     
        setTimeout(() => {
          toast.success("Sales Representative updated successfully!");
        }, 1000);
      }
      if (res.data.code === 2) {
        setTimeout(() => {
          toast.warn(res.data.message);
        }, 1000);
      }
    } catch (err) {
      if(err.response.data.errors[0].message){
        toast.error(err.response.data.errors[0].message);
      }
    }
};

// Delete Sales Representative
export const deleteSalesRepresentative = (id) => async (dispatch) => {
  try {
    if(!id){
      toast.error("Please select any record");
      return false;
    }
    const res = await axios.post(`/salesR/delete/${id}`);
    if (res.data.code === 1) {
        dispatch({ type: DELETE_SALES_REPRESENTATIVE, payload: {id} });
        setTimeout(() => {
          toast.success("Sales Representative deleted successfully!");
        }, 1000);
      }
      if (res.data.code === 2) {
        setTimeout(() => {
          toast.warn(res.data.message);
        }, 1000);
      }
  } catch (err) {
    if(err.response.data.errors[0].message){
      toast.error(err.response.data.errors[0].message);
    }
    // toast.error("Failed to delete color. Please try again.");
  }
};

export const getSingleSalesRepresentative = (id) => async (dispatch) => {
  try {
    const res = await axios.get(`/salesR/${id}`);
    if (res.data.code === 1) {
      dispatch({ type: GET_ONE_SALES_REPRESENTATIVE, payload: res.data.data });
    }
  } catch (err) {
    console.error('Failed to get item by finish item. Please try again.');
    if (err.response.data.message) {
      toast.error(err.response.data.message);
    }
  }
};